import WholeGraphDialog from "./choose-cmpx-dialog";
export default WholeGraphDialog;
